import * as i from 'io-ts';
import { pipe } from 'fp-ts/function';
import * as E from 'fp-ts/Either';
import * as Err from '@fixtuur/error-context';
import { formatValidationErrors } from 'io-ts-reporters';
import { IOError } from '../base';
/** Types related to items stored in s3 for toastie */
export const FileKind = i.keyof({ attachments: null, model: null });
export const FileExtension = i.keyof({ json: null, glb: null, max: null, blend: null });
/** Expected metadata stored alongside a model file in s3 */
export const Data = i.type({
    // NOTE: all keys must be lowercase (turns out s3 url metadata doesn't preserve case)
    tenant: i.string,
    productid: i.string,
    articletype: i.string,
    filekind: FileKind,
    fileextension: FileExtension,
});
export const fromUnknown = (item) => {
    return pipe(item, Data.decode, E.mapLeft(formatValidationErrors), E.mapLeft(errorList => Err.construct(IOError.UnableToDecode, {
        errors: JSON.stringify(errorList),
    })));
};
